import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { Badge } from '@/shared/ui/badge';
import { Icon } from '@/shared/ui/icon';
import './product-detail.scss';
import { ProductDetailContext } from './provider';

type AllergenItem = {
    id: string;
    internalName?: string;
    name?: Record<string, string>;
    sortIndex?: number;
};

type Props = {
    allergens?: AllergenItem[];
};
export const ProductDetailInfoAlergens = ({ allergens: allergensProp }: Props) => {
    const { currentItem } = useContext(ProductDetailContext);
    const allergens = allergensProp ?? currentItem?.allergens;
    const t = useTranslations();

    if (!allergens || !allergens.length) {
        return null;
    }

    return (
        <div className="product-detail__info-alergens" data-testid="product-detail-alergens">
            <div className="product-detail__info-alergens-label">
                <Icon name="wheat" width={24} height={24} />
                <span>Alergeny</span>
            </div>
            <div className="product-detail__info-alergens-badges" data-testid="product-detail-alergens-list">
                {allergens.map((allergen, index) => {
                    // TODO: add number to allergens
                    const displayValue = allergen.internalName
                        ? t(`ALLERGEN.${allergen.internalName}.NUMBER` as Parameters<typeof t>[0])
                        : (allergen.sortIndex ?? index + 1);
                    return (
                        <Badge
                            key={allergen.id}
                            appearance="outline"
                            className="product-detail__info-alergens-badge"
                            data-testid="product-detail-alergen-badge"
                            data-value={allergen.sortIndex ?? index + 1}
                        >
                            {displayValue}.
                        </Badge>
                    );
                })}
            </div>
        </div>
    );
};
